<template>
  <div>
    <div>
      <div style="display:flex;justify-content: space-between;padding-top: 10px">
        <button
          v-b-modal.add-article-direct
          class="button"
        >
          {{ $t('AddArticle') }}
        </button>
      </div>
      <div
        class="tt"
        style="padding-top: 10px"
      >
        <p><strong>{{ $t('AddedArticles') }}</strong></p>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('ArticleNumber') }}</th>
              <th>{{ $t('AddColor') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(material, index) in addedArticles"
              :key="index"
            >
              <td>{{ material.name }}</td>
              <td>
                <button
                  v-b-modal.add-color-direct
                  class="button"
                  @click="takeArticleId(material)"
                >
                  {{ $t('AddColor') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="tt"
        style="padding-top: 10px"
      >
        <p><strong>{{ $t('AddedColors') }}</strong></p>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('ArticleNumber') }}</th>
              <th>{{ $t('Color') }}</th>
              <th>{{ $t('AddBarcode') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(material, index) in addedColors"
              :key="index"
            >
              <td>{{ material.articleName }}</td>
              <td>{{ material.colorName }}</td>
              <td>
                <button
                  v-b-modal.add-barcode-direct
                  class="button"
                  @click="takeArticleColorIds(material)"
                >
                  {{ $t('AddBarcode') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="tt"
        style="padding-top: 10px"
      >
        <p><strong>{{ $t('AddedArticlesWithBarcode') }}</strong></p>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('ArticleNumber') }}</th>
              <th>{{ $t('Barcode') }}</th>
              <th>{{ $t('DownloadBarcode') }}</th>
              <th>{{ $t('Size') }}</th>
              <th>{{ $t('SellingPrice') }}</th>
              <th>{{ $t('PurchasePrice') }}</th>
              <th>{{ $t('DoYouWantToAddToBuy') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(material, index) in addedArticlesWithBarcode"
              :key="index"
            >
              <td>{{ material.articleName }}</td>
              <td>
                {{ material.barcode }}
              </td>
              <td
                style="display:flex;gap:5px;align-items: center;"
              >
                <button
                  v-if="material?.barcode"
                  v-b-tooltip.hover.bottom
                  :title="$t('DownloadBarcode')"
                  class="button"
                  style="width:100px;"
                  @click.stop="downloadBARCODE(material.barcode);"
                >
                  <b-icon-download />
                </button>
                <p v-else>
                  {{ $t('NoBarcode') }}
                </p>
              </td>
              <td>
                <div style="display:flex;gap:2px;">
                  <p
                    v-for="(sizes, index) in material.size"
                    :key="index"
                  >
                    {{ sizes }},
                  </p>
                </div>
              </td>
              <td>
                {{ material.sellingPrice }}
              </td>
              <td>
                {{ material.purchasePrice }}
              </td>
              <td
                style="display:flex;gap:5px;justify-content: center;"
              >
                <button
                  v-if="material?.barcode"
                  class="button"
                  @click.stop="addToDirect(material.barcode);"
                >
                  <b-icon-download />
                </button>
                <p v-else>
                  {{ $t('NoBarcode') }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <AddArticle
      @addArticle="addNewArticle"
    />
    <AddColor
      :article-id="articleId"
      :article-name="articleName"
      @addColor="addNewColor"
    />
    <AddBarcode
      :main-dress-color-id="mainDressColorId"
      :main-dress-id="mainDressId"
      :main-color-article-name="mainColorArticleName"
      @addBarcode="addArticleBarcode"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import JsBarcode from 'jsbarcode';
import AddArticle from './AddArticle.vue'
import AddColor from './AddColor.vue';
import AddBarcode from './AddBarcode.vue';


export default {
  components: {
    AddArticle,
    AddColor,
    AddBarcode,
  },
  data() {
    return {
      addedArticles: [],
      addedColors: [],
      addedArticlesWithBarcode: [],
      articleId: null,
      mainDressColorId: null,
      mainDressId: null,
      mainColorArticleName: null,
      articleNumberBarCode: null,
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions(['addMainDressCategory', 'addInventoryProductSize', 'addColorToMainDressCategoryById']),
    addToDirect(value) {
      this.$emit('addToDirect', value)
    },
    async generateAndDownloadBarCode() {
      const value = this.articleNumberBarCode;

      try {
        const canvas = document.createElement('canvas');

        // Check if the value can be an EAN-13 barcode (must be 12 or 13 digits)
        let format = 'CODE128'; // Default to CODE128

        // EAN-13 format check: Should be a 13-digit number
        if (/^\d{12,13}$/.test(value)) {
          format = 'EAN13';
        }

        // Generate the barcode with the chosen format
        JsBarcode(canvas, value, { format });

        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `Barcode - ${value}.png`;
        link.click();
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    },
    downloadBARCODE(value) {
      this.articleNumberBarCode = value
      this.generateAndDownloadBarCode();
    },
    addArticleBarcode(object) {
      this.addInventoryProductSize({
        object,
        successCallback: () => {
          this.addedArticlesWithBarcode.push({
            barcode: object.code,
            size: object.sizes,
            sellingPrice: object.price,
            purchasePrice: object.purchasePrice,
            articleName: object.articleName,
          })
        },
      });
    },
    takeArticleColorIds(value) {
      this.mainDressColorId = value.mainDressCategoryColorId
      this.mainDressId = value.mainDressCategoryId
      this.mainColorArticleName = {
        name: value.articleName,
        color: value.colorName,
      }
    },
    takeArticleId(value) {
      this.articleId = value.id
      this.articleName = value.name
    },
    addNewArticle(obj) {
      this.addMainDressCategory({
        object: obj,
        successCallback: (response) => {
          this.addedArticles.push({
            ...response,
          });
        },
      });
    },
    addNewColor(obj) {
      this.addColorToMainDressCategoryById({
        object: obj,
        successCallback: (response) => {
          this.addedColors.push({
            articleName: obj.articleName,
            mainDressCategoryId: obj.mainDressCategoryId,
            ...response,
          });
        },
      });
    },
  },
}
</script>

    <style lang="scss" scoped>

    </style>
